import React from 'react';
import NotFound from './NotFound';
import ServerDead from './ServerDead';
import BadRequest from './BadRequest';
import UnAuthorized from './UnAuthorized';
import UnknownError from './UnknownError';

type Error = {
    status: number;
    [key: string]: any;
};

type Errors = Error[];

type ErrorController = (errors: unknown[]) => { hasError: boolean; errorCmp: JSX.Element };

const errorController: ErrorController = (errors) => {
    let hasError = false;
    let element = <></>;

    (errors as Errors)?.some((error) => {
        if (error) {
            const status = error.status || error.response?.status;

            if (status === 400) {
                hasError = true;
                element = <BadRequest />;
                return true;
            }

            if (status === 401) {
                hasError = true;
                element = <UnAuthorized />;
                return true;
            }

            if (status === 404) {
                hasError = true;
                element = <NotFound />;
                return true;
            }

            if (status === 500) {
                hasError = true;
                element = <ServerDead />;
                return true;
            }

            if (status !== undefined || typeof error === 'undefined') {
                hasError = true;
                element = <UnknownError />;
                return true;
            }
        }

        return false;
    });

    return {
        hasError,
        errorCmp: element
    };
};

export default errorController;
